import React from 'react';
import classnames from 'classnames';
import { useThemeVarsClass } from '../../../../theme/provider';
import cn from './styles.module.scss';

export type NumberProgressClassNames = {
  root?: string;
  value?: string;
  current?: string;
  total?: string;
  label?: string;
};

export type NumberProgressProps = {
  current: number;
  total: number;
  label: string;
  className?: string;
  classNames?: NumberProgressClassNames;
};

export function NumberProgress({
  current,
  total,
  label,
  className,
  classNames: classNamesProp,
}: NumberProgressProps) {
  const themeClassName = useThemeVarsClass();

  return (
    <div className={classnames(cn.root, themeClassName, className, classNamesProp?.root)}>
      <div className={classnames(cn.value, classNamesProp?.value)}>
        <span className={classnames(cn.current, classNamesProp?.current)}>{current}</span>
        <span className={classnames(cn.total, classNamesProp?.total)}>
          /
          {total}
        </span>
      </div>
      <span className={classnames(cn.label, classNamesProp?.label)}>{label}</span>
    </div>
  );
}
